import utils from 'utils'
import detailPage from './view/detail.html'
import downloadModel from './view/downloadModel.html'
import sendEmailModel from './view/sendEmail.html'
import redInkConfirmFormChooseUkeyModal from './view/redInkConfirmFormChooseUkeyModal.html'
import warnModal from './view/warnModal.html'
import authenticationModalTemplate from '../../../main/common/authenticationModalList.html'
import certificationModalTemplate from '../../../main/common/certificationModalList.html'
export default class redInkConfirmFormListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, sweetalert, initSortService, composeService, $location, dictService) {
        $scope.dictData = {}
        $scope.dictData.cust_identity = [
            {
                enumCode: '0',
                enumName: '我是销售方',
            },
            {
                enumCode: '1',
                enumName: '我是购买方',
            },
        ]
        $scope.profileType = '210'
        $scope.selectedRows = []
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                custIdentity: '0',
            },
        }
        $scope.customizedConfig = {
            version: 1.21,
            queryForm: [
                {
                    // 0
                    label: '单据编号',
                    selected: true,
                    default: true,
                },
                {
                    label: '购销方',
                    selected: true,
                    default: true,
                },
                {
                    label: '录入方身份',
                    selected: true,
                    default: true,
                },
                {
                    label: '内部审核状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '确认单状态',
                    selected: true,
                    default: true,
                },
                {
                    // 5
                    label: '确认单来源',
                    selected: true,
                    default: true,
                },
                {
                    label: '对方纳税人名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '对方纳税人税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '冲红原因',
                    selected: true,
                    default: true,
                },
                {
                    label: '红字确认单编号',
                    selected: false,
                    default: false,
                },
                {
                    // 10
                    // label: '开票点',
                    // selected: false,
                    // default: false,
                },
                {
                    label: '申请人',
                    selected: false,
                    default: false,
                },
                {
                    label: '申请日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '审核人',
                    selected: false,
                    default: false,
                },
                {
                    label: '审核日期',
                    selected: false,
                    default: false,
                },
                {
                    // 15
                    label: '上传日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '确认日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '开具状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '开票日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '红票全电发票号码',
                    selected: false,
                    default: false,
                },
                {
                    // 20
                    label: '对应蓝票全电发票号码',
                    selected: false,
                    default: false,
                },
                {
                    label: '对应蓝票发票代码',
                    selected: false,
                    default: false,
                },
                {
                    label: '对应蓝票发票号码',
                    selected: false,
                    default: false,
                },
                {
                    label: '流水号',
                    selected: false,
                    default: false,
                },
                {
                    label: '业务单据号',
                    selected: false,
                    default: false,
                },
                {
                    // 25
                    label: '合同号',
                    selected: false,
                    default: false,
                },
                {
                    label: '项目名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '扩展1',
                    selected: false,
                    default: false,
                },
                {
                    label: '扩展2',
                    selected: false,
                    default: false,
                },
                {
                    label: '扩展3',
                    selected: false,
                    default: false,
                },
                {
                    // 30
                    label: '提醒邮件发送状态',
                    selected: false,
                    default: false,
                },
            ],
            table: [
                {
                    // 0
                    label: '单据编号',
                    selected: true,
                    default: true,
                },
                {
                    label: '购销身份',
                    selected: true,
                    default: true,
                },
                {
                    label: '对方纳税人名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '对方纳税人税号',
                    selected: true,
                    default: true,
                },
                {
                    label: '对应蓝票全电发票号码',
                    selected: true,
                    default: true,
                },
                {
                    // 5
                    label: '对应蓝票发票代码',
                    selected: false,
                    default: false,
                },
                {
                    label: '对应蓝票发票号码',
                    selected: false,
                    default: false,
                },
                {
                    label: '红字确认单编号',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票税额',
                    selected: true,
                    default: true,
                },
                {
                    // 10
                    label: '价税合计',
                    selected: true,
                    default: true,
                },
                {
                    label: '冲红原因',
                    selected: true,
                    default: true,
                },
                {
                    label: '内部审核状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '确认单状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '录入方身份',
                    selected: false,
                    default: false,
                },
                {
                    // 15
                    label: '开票点',
                    selected: false,
                    default: false,
                },
                {
                    label: '申请人',
                    selected: false,
                    default: false,
                },
                {
                    label: '申请日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '审核人',
                    selected: false,
                    default: false,
                },
                {
                    label: '审核日期',
                    selected: false,
                    default: false,
                },
                {
                    // 20
                    label: '上传日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '失败原因描述',
                    selected: false,
                    default: false,
                },
                {
                    label: '确认日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '开具状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: false,
                    default: false,
                },
                {
                    // 25
                    label: '红票全电发票号码',
                    selected: false,
                    default: false,
                },
                {
                    label: '业务单据号',
                    selected: false,
                    default: false,
                },
                {
                    label: '流水号',
                    selected: false,
                    default: false,
                },
                {
                    label: '确认单来源',
                    selected: false,
                    default: false,
                },
                {
                    label: '提醒邮件发送状态',
                    selected: false,
                    default: false,
                },
                //30
                {
                    label: '确认方名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '确认方邮箱',
                    selected: false,
                    default: false,
                },
                {
                    label: '收票邮箱',
                    selected: false,
                    default: false,
                },
            ],
        }
        const pathParam = $location.path().replace(/\//g, '-')
        $scope.orderMap = initSortService(pathParam)
        $scope.param.orderMap = $scope.orderMap.wrap
        $scope.ukeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList
        $scope.saleCreditCode = JSON.parse(localStorage.getItem('user_info')).sale.saleCreditCode
        $scope.orgName = JSON.parse(localStorage.getItem('user_info')).org.orgName
        $scope.isUkey = false
        if ($scope.ukeyList && $scope.ukeyList.length > 0) {
            $scope.isUkey = true
        }
        function chooseUkey(title, tips, ukeyId) {
            return $uibModal
                .open({
                    template: redInkConfirmFormChooseUkeyModal,
                    controller: 'redInkConfirmFormChooseUkeyModal',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return { title, tips, ukeyId }
                        },
                    },
                })
                .result.then(
                    (ukeyId) => {
                        return ukeyId
                    },
                    () => {
                        return ''
                    }
                )
        }
        $scope.filterUkeyName = function filterUkeyName(id) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (id === null) {
                return id
            }
            if (userInfo.sysUkeyList === null) {
                return id
            }
            const fliterUkeyNameArr = userInfo.sysUkeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }

        const getDict = () => {
            const dictTypeArr = ['identity', 'red_confirm_red_reason', 'red_confirm_open_status', 'red_confirm_status', 'red_confirm_work_status', 'red_confirm_data_source','red_confirm_mail_send_status']
            httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res) => {
                $scope.dictData = $.extend($scope.dictData, res.data.value)
            })
        }
        $scope.reset = function () {
            $scope.param = {
                pageNum: 1,
                pageSize: 10,
                param: {
                    custIdentity: '0',
                },
            }
        }
        //查询功能，和表头排序功能
        const queryRedInfo = function queryList(msg) {
            $scope.param = sessionStorage[pathParam] ? JSON.parse(sessionStorage[pathParam]) : $scope.param
            httpRequest
                .post_tax4RedListByPage($scope.param)
                .then((res) => {
                    let result = res.data.value
                    $scope.dataList = result.list
                    $scope.totalItems = result.total
                    $scope.param.pageNum = result.pageNum
                    $scope.selectedRows = []
                })
                .finally(() => {
                    if (msg) {
                        logger.logSuccess(msg)
                    }
                })
        }
        $scope.init = composeService(queryRedInfo, getDict)
        $scope.init()
        let searchParam = sessionStorage[pathParam] ? JSON.parse(sessionStorage[pathParam]) : $scope.param
        for (const paramKey in searchParam.param) {
            switch (paramKey) {
                case 'custIdentity':
                    if (searchParam.param.custIdentity == '0') break
                default:
                    if (searchParam.param[paramKey]) {
                        $scope.toggle = true
                    }
            }
        }
        $scope.selectedHandle = function () {
            $scope.param.orderMap = $scope.orderMap.wrap
            sessionStorage.setItem(pathParam, JSON.stringify($scope.param))
            queryRedInfo()
        }
        $scope.search = function () {
            sessionStorage.setItem(pathParam, JSON.stringify($scope.param))
            queryRedInfo()
        }
        $scope.pageChanged = function () {
            // 点击页码发起查询
            let params = JSON.stringify({
                orderMap: $scope.param.orderMap,
                pageNum: $scope.param.pageNum,
                pageSize: $scope.param.pageSize,
                param: sessionStorage[pathParam] ? JSON.parse(sessionStorage[pathParam]).param : $scope.param.param,
            })
            sessionStorage.setItem(pathParam, params)
            queryRedInfo()
        }

        // 表头排序分页查询功能结束

        $scope.tableDropdownConfig = [
            {
                label: '查看',
                handler(item) {
                    $uibModal
                        .open({
                            template: detailPage,
                            controller: 'redInkConfirmFormDetailCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-hg-g',
                            resolve: {
                                items1() {
                                    return {
                                        item: item,
                                        title: '详情信息',
                                    }
                                },
                            },
                        })
                        .result.then(
                            () => {},
                            () => {}
                        )
                },
            },
            {
                label: '编辑',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.add', {
                        currentTab: 'inforConfirmTab',
                        confirmId: item.confirmId,
                    })
                },
                showWhile(item, hasPermit) {
                    //1确认单来源为“手工新增”或“接口”； dataSource  0手工新增 3接口
                    //2内部审核状态为“待提交”或“审核不通过”或“被回退”； workflowStatus -1待提交 3审核不通过 4被回退
                    //3确认单状态为“未上传”或“上传失败”。  confirmStatus 0未上传 1上传失败
                    return (
                        hasPermit('redConfirmEdit') &&
                        (item.dataSource == '0' || item.dataSource == '3') &&
                        (item.workflowStatus == '-1' || item.workflowStatus == '3' || item.workflowStatus == '4') &&
                        (item.confirmStatus === '0' || item.confirmStatus === '1')
                    )
                },
            },
            {
                label: '提交',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $scope.oneSubmit(item)
                },
                showWhile(item, hasPermit) {
                    return (
                        hasPermit('redConfirmSubmit') &&
                        (item.dataSource == '0' || item.dataSource == '3') &&
                        (item.workflowStatus == '-1' || item.workflowStatus == '3' || item.workflowStatus == '4') &&
                        (item.confirmStatus === '0' || item.confirmStatus === '1')
                    )
                },
            },
            {
                label: '开票',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.invoice', {
                        confirmIds: item.confirmId,
                        total: 1,
                        type: '1',
                        ukeyId: item.ukeyId,
                    })
                },
                showWhile(item, hasPermit) {
                    //确认单状态 confirmStatus 01无需确认  04购销双方已确认
                    //开具状态 openStatus  0未开具  3开具失败
                    //销购身份为“销售方”  0销售方
                    //内部审核状态为“审核通过”或“无需审核”； workflowStatus 1审核通过  2无需审核
                    return (
                        hasPermit('redConfirmOpen') &&
                        (item.confirmStatus === '01' || item.confirmStatus === '04') &&
                        (item.openStatus == '0' || item.openStatus == '3') &&
                        item.custIdentity == '0' &&
                        (item.workflowStatus == '1' || item.workflowStatus == '2')
                    )
                },
            },
            {
                label: '确认',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.confirm', {
                        confirmIds: item.confirmId,
                        total: 1,
                        type: '1',
                        ukeyId: item.ukeyId,
                    })
                },
                showWhile(item, hasPermit) {
                    return (
                        hasPermit('redConfirmOK') &&
                        ((item.confirmStatus == '02' && item.custCreditCode == $scope.saleCreditCode) || (item.confirmStatus == '03' && item.saleCreditCode == $scope.saleCreditCode))
                    )
                },
            },
            {
                label: '更新',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $scope.batchUpdate(item)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('redConfirmUpdate') && (item.confirmStatus == '01' || item.confirmStatus == '02' || item.confirmStatus == '03' || item.confirmStatus == '04')
                },
            },
            {
                label: '撤销',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $scope.oneRevoke(item)
                },
                showWhile(item, hasPermit) {
                    //确认单状态 confirmStatus  01无需确认 02销方录入待购方确认 03购方录入待销方确认 04购销双方已确认
                    //开具状态 openStatus 0未开具 3开具失败
                    //录入方身份 createIdentity 0销售方 1购买方

                    // 确认即开票标志为Y，且确认单状态为 无需确认时，不可撤销
                    if (item.confirmApplyFlag === 'Y' && item.confirmStatus === '01') {
                        return false
                    }
                    // 开具状态为“未开具”红字确认单，若红字确认单状态为“购销双方已确认”的：当前操作机构若为确认方才可撤销，匹配当前机构名称与确认方名称是否一致
                    if(item.openStatus === '0' && item.confirmStatus === '04' && item.confirmName === $scope.orgName){
                        return true
                    }
                    //开具状态为“未开具”红字确认单,若红字确认单状态为“无需确认”、“销方录入待购方确认”/“购方录入待销方确认”
                    if(item.openStatus === '0' && (item.confirmStatus=== '01' || item.confirmStatus === '02' || item.confirmStatus === '03')){
                        // ①若为销方申请红字确认单，销售方可对这张红字确认单进行撤销操作
                        if(item.createIdentity=='0'){
                            // 1）若机构为销方，显示行按钮【撤销】，能够正常执行撤销操作
                            if(item.saleCreditCode == $scope.saleCreditCode){
                                return true
                            }
                            // 2）若机构为购方，不显示行按钮【撤销】，不允许执行撤销操作
                            if(item.custCreditCode == $scope.saleCreditCode){
                                return false
                            }
                        }
                        // ②若为购方申请红字确认单，购买方可对这张红字确认单进行撤销操作
                        if(item.createIdentity=='1'){
                            // 1）若机构为购方，显示行按钮【撤销】，能够正常执行撤销操作
                            if(item.custCreditCode == $scope.saleCreditCode){
                                return true
                            }
                            // 2）若机构为销方，不显示行按钮【撤销】，不允许执行撤销操作
                            if(item.saleCreditCode == $scope.saleCreditCode){
                                return false
                            }
                        }
                    }
                },
            },
            {
                label: '删除',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $scope.batchDelete(item)
                },
                showWhile(item, hasPermit) {
                    return (
                        hasPermit('redConfirmDel') &&
                        (item.dataSource == '0' || item.dataSource == '3') &&
                        (item.workflowStatus == '-1' || item.workflowStatus == '3' || item.workflowStatus == '4') &&
                        (item.confirmStatus === '0' || item.confirmStatus === '1')
                    )
                },
            },
            {
                label: '上传税局',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $scope.oneUpload(item)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('redConfirmUpload') && (item.workflowStatus == '1' || item.workflowStatus == '2') && (item.confirmStatus == '0' || item.confirmStatus == '1')
                },
            },
            {
                label: '回退',
                handler(item) {
                    if (!$scope.isUkey) {
                        logger.logError('暂无开票点，禁止操作。')
                        return
                    }
                    $scope.oneBack(item)
                },
                showWhile(item, hasPermit) {
                    // 被回退状态确认单的不能再次操作回退
                    if (item.workflowStatus == '4') {
                        return false
                    }
                    // 确认单的录入方与当前操作机构需一致
                    if(item.custIdentity=='0'){ //①若为销方申请，录入方即为销售方
                        if(item.saleCreditCode != $scope.saleCreditCode){
                            return false
                        }
                    }
                    if(item.custIdentity=='1'){ //②若为购方申请，录入方即为购买方
                        if(item.custCreditCode != $scope.saleCreditCode){
                            return false
                        }
                    }
                    let flag = false
                    // 根据确认单来源判断
                    switch (item.dataSource) {
                        case 0: //手工新增
                        case 1: //税局下载
                            // 审核状态为 "审核通过" 或 "无需审核"
                            if (['1', '2'].indexOf(item.workflowStatus) !== -1) {
                                // 确认单状态为 "未上传" 或 "上传失败"
                                if (['0', '1'].indexOf(item.confirmStatus) !== -1) {
                                    flag = true // 可回退
                                }
                            }
                            // 有关联销售单且为 审核通过, 开具状态为 "未开具" 或 "开具失败"
                            if (item.isList == '1' && item.workflowStatus == '1' && ['0', '3'].indexOf(item.openStatus) !== -1) {
                                flag = true // 可回退
                            }
                            break
                        case 2: //销售单
                            if (['01', '02', '04'].indexOf(item.confirmStatus) !== -1) {
                                // 确认单来源为“销售单” 确认单状态不是“未上传”且不是作废状态时，
                                // 即状态为“销方申请待购方确认”或“无需确认”或“购销双方已确认”，此时不可回退，不显示【回退】按钮。
                            } else {
                                flag = true // 可回退
                            }
                            break
                    }
                    return hasPermit('redConfirmBack') && flag
                },
            },
            {
                label: '发送确认提醒',
                handler(item) {
                    $scope.batchSend(item)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('sendRemind') && (item.confirmStatus == '02' || item.confirmStatus == '03')
                },
            },
        ]
        // 批量操作
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量提交',
                    hasPermit: 'redConfirmSubmit',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }

                        $scope.batchSubmit()
                    },
                },
                {
                    text: '批量上传税局',
                    hasPermit: 'redConfirmUpload',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }
                        $scope.batchUpload()
                    },
                },
                {
                    text: '批量更新',
                    hasPermit: 'redConfirmUpdate',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }
                        $scope.batchUpdate()
                    },
                },
                {
                    text: '批量开票',
                    hasPermit: 'redConfirmOpen',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }
                        if (!$scope.selectedRows.length) {
                            return logger.logError('请选择要开票的数据行')
                        }
                        let checkRows = $scope.selectedRows.some((item) => {
                            return !(
                                (item.confirmStatus === '01' || item.confirmStatus === '04') &&
                                (item.openStatus == '0' || item.openStatus == '3') &&
                                item.custIdentity == '0' &&
                                (item.workflowStatus == '1' || item.workflowStatus == '2')
                            )
                        })
                        if (checkRows) {
                            return logger.logError(
                                '内部审核状态为“审核通过”或“无需审核”，确认单状态为“无需确认”或“购销双方已确认”，且开具状态为“未开具”或“开具失败”，销购身份为“销售方”的红字确认单才可开票，请核实后重新选择。'
                            )
                        }
                        const confirmIds = $scope.selectedRows.map((row) => {
                            return row.confirmId
                        })
                        $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.invoice', {
                            confirmIds: confirmIds,
                            total: $scope.selectedRows.length,
                            type: '2',
                            ukeyId: $scope.selectedRows[0].ukeyId,
                        })
                    },
                },
                {
                    text: '批量确认',
                    hasPermit: 'redConfirmOK',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }
                        if (!$scope.selectedRows.length) {
                            return logger.logError('请选择要确认的数据行')
                        }
                        let checkRows = $scope.selectedRows.some((item) => {
                            return !((item.confirmStatus == '02' && item.custCreditCode == $scope.saleCreditCode) || (item.confirmStatus == '03' && item.saleCreditCode == $scope.saleCreditCode))
                        })
                        if (checkRows) {
                            return logger.logError('只有确认单状态为“购方录入待销方确认”或“销方录入待购方确认”且购销身份与录入方身份不一致的确认单才可进行确认操作，请核实后重新选择再操作。')
                        }
                        const confirmIds = $scope.selectedRows.map((row) => {
                            return row.confirmId
                        })
                        $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.confirm', {
                            confirmIds: confirmIds,
                            total: $scope.selectedRows.length,
                            type: '2',
                            ukeyId: $scope.selectedRows[0].ukeyId,
                        })
                    },
                },
                {
                    text: '批量回退',
                    hasPermit: 'redConfirmBack',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }
                        $scope.batchBack()
                    },
                },
                {
                    text: '批量撤销',
                    hasPermit: 'redConfirmRevoke',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }
                        $scope.batchRevoke()
                    },
                },
                {
                    text: '批量删除',
                    hasPermit: 'redConfirmDel',
                    handler() {
                        if (!$scope.isUkey) {
                            logger.logError('暂无开票点，禁止操作。')
                            return
                        }
                        $scope.batchDelete()
                    },
                },
                {
                    text: '发送确认提醒',
                    hasPermit: 'sendRemind',
                    handler() {
                        $scope.batchSend()
                    },
                },
            ],
        }
        $scope.add = function () {
            if (!$scope.isUkey) {
                logger.logError('暂无开票点，禁止操作。')
                return
            }
            $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.add')
        }
        $scope.download = function () {
            if (!$scope.isUkey) {
                logger.logError('暂无开票点，禁止操作。')
                return
            }
            $uibModal
                .open({
                    template: downloadModel,
                    controller: 'redInkConfirmFormDownloadCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-hg-g',
                    resolve: {
                        items1() {
                            return ''
                        },
                    },
                })
                .result.then(
                    (result) => {
                        if (result) {
                            queryRedInfo()
                        }
                    },
                    () => {}
                )
        }

        function getApproveStatu() {
            return httpRequest.post_qryFlowIsValid({ approveCode: 'tax4_red_comfirm_approve' }).then((res) => {
                return res.data.value
            })
        }
        // 单张提交
        $scope.oneSubmit = async function (item) {
            const approveStatu = await getApproveStatu()
            if (!approveStatu) {
                const ukeyId = await chooseUkey('红字确认单状态提交', '您正在进行将红字确认单提交操作，当前未开启审批，提交后将直接上传税局，请注意更新查看确认单状态。', item.ukeyId)
                if (!ukeyId) return
                // 提交 - 判断是否有审批流 - 无审批流 弹出确认弹窗 再提交，调用上传税局的接口 后直接跳转页面查询详情展示结果 /  有审批流 提交后直接跳转页面查询详情展示结果
                httpRequest.post_submitRedConfirm({ confirmId: item.confirmId }).then((res1) => {
                    logger.logSuccess(res1.data.value)
                    let ukeyList = $scope.userInfo.tax4UkeyList.filter(u => {
                        return u.ukeyId == ukeyId;
                    });
                    let mes = ''
                    if(ukeyList[0].manageType === '6' && item.confirmApplyFlag === 'Y' && item.confirmStatus === '01'){
                        mes = '本次红字确认单上传税局申请成功后，将直接生成红字发票，请确定是否继续提交?'
                    }
                    if(ukeyList[0].manageType === '6' && item.confirmApplyFlag === 'Y' && (item.confirmStatus === '02' || item.confirmStatus === '03')){
                        mes = '本次红字确认单上传税局申请成功后，需经对方确认，确认方确认后将直接生成红字发票，请确定是否继续提交?'
                    }
                    if(mes){
                        sweetalert.confirm('温馨提示', mes).then(() => {
                            realOneSubmit(item,ukeyId)
                        })
                    }else {
                        realOneSubmit(item,ukeyId)
                    }
                })
            } else {
                httpRequest.post_submitRedConfirm({ confirmId: item.confirmId }).then((res) => {
                    logger.logSuccess(res.data.value)
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.add', {
                        currentTab: 'submitSuccessTab',
                        confirmId: item.confirmId,
                    })
                })
            }
        }
        function realOneSubmit(item,ukeyId) {
            httpRequest.post_uploadRedConfirm(item.confirmId, ukeyId).then((res) => {
                if (res.data.msgCode === 2002 || res.data.msgCode === 2003) {
                    logger.logSuccess(res.data.message)
                    $uibModal.open({
                        template: authenticationModalTemplate,
                        controller: 'authenticationModalCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-lg',
                        resolve: {
                            items1() {
                                return {
                                    authorizeId: res.data.emsg,
                                    mobile: res.data.message.substring(10),
                                }
                            },
                        },
                    })
                } else if (res.data.msgCode === -99998) {
                    $uibModal.open({
                        template: certificationModalTemplate,
                        controller: 'certificationModalCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-lg',
                        resolve: {
                            items1() {
                                return { authorizeId: res.data.emsg }
                            },
                        },
                    })
                } else {
                    console.log(`上传成功${res.data.value.successNum}条，失败${res.data.value.failNum}条。`)
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.add', {
                        currentTab: 'submitSuccessTab',
                        confirmId: item.confirmId,
                    })
                }
            })
        }
        // 批量提交
        $scope.batchSubmit = async function () {
            let selectedRows = $scope.selectedRows
            if (!selectedRows.length) {
                return logger.logError('请选择要提交的数据行')
            }

            let checkRows = selectedRows.some((ele) => {
                return !(
                    (ele.dataSource == '0' || ele.dataSource == '3') &&
                    (ele.workflowStatus == '-1' || ele.workflowStatus == '3' || ele.workflowStatus == '4') &&
                    (ele.confirmStatus === '0' || ele.confirmStatus === '1')
                )
            })
            if (checkRows) {
                return logger.logError('确认单来源为“手工新增”或“接口”，内部审核状态为“待提交”或“审核不通过”或“被回退”，确认单状态为“未上传”或“上传失败”的红字确认单才可提交，请核实后重新选择。')
            }
            const approveStatu = await getApproveStatu()
            let ukeyId
            if (!approveStatu) {
                ukeyId = await chooseUkey('红字确认单状态提交', '您正在进行将红字确认单提交操作，当前未开启审批，提交后将直接上传税局，请注意更新查看确认单状态。', selectedRows[0].ukeyId)
                if (!ukeyId) return
            }
            sweetalert.confirm('提交提醒', '确认提交所选的发票信息？').then(() => {
                const confirmIds = selectedRows.map((row) => {
                    return row.confirmId
                })
                let data = {
                    confirmIds: confirmIds,
                    ukeyId: ukeyId,
                }
                httpRequest.post_batchSubmitRedConfirm(data).then((res) => {
                    const value = res.data.value
                    if (value.uploadSuccessNum || value.uploadFailNum) {
                        logger.logSuccess(`提交成功${value.submitSuccessNum}条，提交失败${value.submitFailNum}条，上传税局成功${value.uploadSuccessNum}条，上传税局失败${value.uploadFailNum}条。`)
                    } else {
                        logger.logSuccess(`提交成功${value.submitSuccessNum}条，提交失败${value.submitFailNum}条，其中提交成功的已进入审批流，请等待审核通过后，再上传税局。`)
                    }

                    queryRedInfo()
                })
            })
        }
        // 批量更新
        $scope.batchUpdate = async function (item) {
            let selectedRows = []
            if (item) {
                selectedRows = [item]
            } else {
                selectedRows = $scope.selectedRows
            }
            if (!selectedRows.length) {
                return logger.logError('请选择要更新的数据行')
            }
            let checkRows = selectedRows.some((ele) => {
                return !(ele.confirmStatus == '01' || ele.confirmStatus == '02' || ele.confirmStatus == '03' || ele.confirmStatus == '04')
            })
            if (checkRows) {
                return logger.logError('仅开具状态为“未开具”或确认单状态为“无需确认”、“销方录入待购方确认”、“购方录入待销方确认”或“购销双方已确认”的确认单才调接口进行查询并更新状态。')
            }
            const ukeyId = await chooseUkey('红字确认单状态更新', '您正在进行红字确认单状态更新操作，更新后请注意查看确认单状态和开票状态。', selectedRows[0].ukeyId)
            if (!ukeyId) return
            sweetalert.confirm('更新提醒', '确认更新所选的发票信息？').then(() => {
                const confirmIds = selectedRows.map((row) => {
                    return row.confirmId
                })
                utils.loading('请求已发送')
                httpRequest.post_batchUpdateRedConfirmFromTaxBureau(confirmIds, ukeyId).then(() => {
                    utils.loaded()
                    queryRedInfo('确认单状态已更新！')
                })
            })
        }
        // 单张上传税局
        $scope.oneUpload = async function (item) {
            const ukeyId = await chooseUkey('上传税局', '您正在进行将红字确认单上传到税局的操作，上传后请注意更新查看确认单状态。', item.ukeyId)
            if (!ukeyId) return
            let ukeyList = $scope.userInfo.tax4UkeyList.filter(u => {
                return u.ukeyId == ukeyId;
            });
            let mes = ''
            if(ukeyList[0].manageType === '6' && item.confirmApplyFlag === 'Y' && item.confirmStatus === '01'){
                mes = '本次红字确认单上传税局申请成功后，将直接生成红字发票，请确定是否继续提交?'
            }
            if(ukeyList[0].manageType === '6' && item.confirmApplyFlag === 'Y' && (item.confirmStatus === '02' || item.confirmStatus === '03')){
                mes = '本次红字确认单上传税局申请成功后，需经对方确认，确认方确认后将直接生成红字发票，请确定是否继续提交?'
            }
            if(mes){
                sweetalert.confirm('温馨提示', mes).then(() => {
                    realOneUpload(item,ukeyId)
                })
            }else {
                realOneUpload(item,ukeyId)
            }
        }
        function realOneUpload(item,ukeyId) {
            httpRequest.post_uploadRedConfirm(item.confirmId, ukeyId).then((res) => {
                if (res.data.msgCode === 2002 || res.data.msgCode === 2003) {
                    logger.logSuccess(res.data.message)
                    $uibModal.open({
                        template: authenticationModalTemplate,
                        controller: 'authenticationModalCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-lg',
                        resolve: {
                            items1() {
                                return {
                                    authorizeId: res.data.emsg,
                                    mobile: res.data.message.substring(10),
                                }
                            },
                        },
                    })
                } else if (res.data.msgCode === -99998) {
                    $uibModal.open({
                        template: certificationModalTemplate,
                        controller: 'certificationModalCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-lg',
                        resolve: {
                            items1() {
                                return { authorizeId: res.data.emsg }
                            },
                        },
                    })
                } else {
                    let message = res.data.value?res.data.value:res.data.message
                    logger.logSuccess(message)
                    queryRedInfo()
                }
            })
        }
        // 批量上传税局
        $scope.batchUpload = async function (item) {
            let selectedRows = []
            if (item) {
                selectedRows = [item]
            } else {
                selectedRows = $scope.selectedRows
            }
            if (!selectedRows.length) {
                return logger.logError('请选择要上传税局的数据行')
            }
            let checkRows = selectedRows.some((ele) => {
                return !((ele.workflowStatus == '1' || ele.workflowStatus == '2') && (ele.confirmStatus == '0' || ele.confirmStatus == '1'))
            })
            if (checkRows) {
                return logger.logError('只有内部审核状态为“审核通过”或“无需审核”，确认单状态为“未上传”或“上传失败”的确认单才可操作上传税局，请核实并重新选择后再操作。')
            }
            const ukeyId = await chooseUkey('上传税局', '您正在进行将红字确认单上传到税局的操作，上传后请注意更新查看确认单状态。', selectedRows[0].ukeyId)
            if (!ukeyId) return
            let ukeyList = $scope.userInfo.tax4UkeyList.filter(u => {
                return u.ukeyId == ukeyId;
            });
            //确认单状态 确认即开票标识为Y
            let confirmApplyFlag = false
            if(selectedRows.some((ele) => ele.confirmApplyFlag === 'Y')){
                confirmApplyFlag = true
            }
            //确认单状态 为“无需确认/购方录入待销方确认/销方录入待购方确认”
            let confirmStatus = false
            if(selectedRows.some((ele) => (ele.confirmStatus == '01' || ele.confirmStatus == '02' || ele.confirmStatus == '03'))){
                confirmStatus = true
            }
            if(ukeyList[0].manageType === '6' || confirmApplyFlag || confirmStatus){
                sweetalert.confirm('温馨提示', '您所选择的确认单中，部分确认单在上传税局申请成功后，将直接生成红字发票，请确定是否继续提交?').then(() => {
                    realbatchUpload(selectedRows,ukeyId)
                })
            }else {
                realbatchUpload(selectedRows,ukeyId)
            }
        }
        function realbatchUpload(selectedRows,ukeyId) {
            sweetalert.confirm('上传税局提醒', '确认所选的发票信息上传税局？').then(() => {
                const confirmIds = selectedRows.map((row) => {
                    return row.confirmId
                })
                httpRequest.post_batchUploadRedConfirm(confirmIds, ukeyId).then((res) => {
                    logger.logSuccess(`上传成功${res.data.value.successNum}条，失败${res.data.value.failNum}条。`)
                    queryRedInfo()
                })
            })
        }
        // 单张回退
        $scope.oneBack = function (item){
            let selectedRows = [item]
            let checkRows = selectedRows.some((ele) => {
                return checkItem(ele)
            })
            if (!checkRows) {
                return logger.logError('未关联销售单或由销售单生成的在上传前可回退，已关联销售单的作废后可回退，有部分所选不符合回退条件请检查。')
            }

            httpRequest.post_singleRollbackAutoCompareCheck(item.confirmId).then((res) => {
                if(res.data.value.compareResult){
                    $uibModal
                        .open({
                            template: warnModal,
                            controller: 'warnModal',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-so-hg',
                            resolve: {
                                items1() {
                                    return res.data.value.confirmVoList
                                },
                            },
                        })
                        .result.then(
                        (data) => {
                            if(data === '关联'){
                                queryRedInfo()
                            }else if(data){
                                realBack(selectedRows,1, false)
                            }
                        }
                    )
                }else if(item.confirmStatus == '1'){
                    sweetalert.confirm('重复上传风险提示', '当前红字确认单数据上一次上传失败，请前往电子税局查看是否已申请成功。如实际已申请成功，请取消回退，避免重复上传；如实际未申请成功，确认后可点击【确定】进行回退。确定继续回退？').then(() => {
                        realBack(selectedRows,1, false)
                    }, () => {
                        console.log('取消')
                    })
                }else {
                    sweetalert.confirm('回退提醒', '确认回退所选的发票信息？').then(() => {
                        realBack(selectedRows, 1, false)
                    })
                }
            })
        }

        // 批量回退
        $scope.batchBack = function (item) {
            let selectedRows = $scope.selectedRows
            if (!selectedRows.length) {
                return logger.logError('请选择要回退的数据行')
            }
            let checkRows = selectedRows.some((ele) => {
                return checkItem(ele)
            })
            if (!checkRows) {
                return logger.logError('未关联销售单或由销售单生成的在上传前可回退，已关联销售单的作废后可回退，确认单的录入方与当前操作机构需一致，有部分所选不符合回退条件请检查。')
            }

            let isConfirmStatus = $scope.selectedRows.filter((el) => el.confirmStatus == '1')
            if (isConfirmStatus.length>0) {
                sweetalert.confirm('自动匹配提示', '批量回退的红字确认单中，若存在上一次上传失败的红字确认单，回退可能存在重复上传风险，E税云将对这些红字确认单执行自动匹配，若匹配上已上传的红字确认单，将更新红字确认单数据，不再进行回退。').then(() => {
                    const confirmIds = selectedRows.map((row) => {
                        return row.confirmId
                    })
                    httpRequest.post_batchRollbackRedConfirm(confirmIds,0, true).then((res) => {
                        let messageList = res.data.value.messageList
                        let flag = false
                        for (let i = 0; i < messageList.length; i++) {
                            if (messageList[i].errorMsg.indexOf('且匹配失败')!= -1) {
                                flag = true
                            }
                        }
                        if(flag){
                            sweetalert.confirm('重复上传风险提示', '批量回退的红字确认单中，存在上一次上传失败且自动匹配未匹配上的红字确认单，回退可能存在重复上传风险，请前往电子税局查看是否已申请成功。如实际已申请成功，请取消回退，避免重复上传；如实际未申请成功，确认后可点击【确定】进行回退。确定继续回退？').then(() => {
                                realBack(selectedRows, 2, true)
                            })
                        }else {
                            realBack(selectedRows, 2, true)
                        }
                    })
                })
            }else {
                sweetalert.confirm('回退提醒', '确认回退所选的发票信息？').then(() => {
                    realBack(selectedRows, 2, true)
                })
            }
        }
        function checkItem(ele) {
            let flag = false
            switch (ele.dataSource) {
            case 0: //手工新增
            case 1: //税局下载
                // 审核状态为 "审核通过" 或 "无需审核"
                if (['1', '2'].indexOf(ele.workflowStatus) !== -1) {
                    // 确认单状态为 "未上传" 或 "上传失败"
                    if (['0', '1'].indexOf(ele.confirmStatus) !== -1  && (ele.custIdentity=='0'&& ele.saleCreditCode == $scope.saleCreditCode)||(ele.custIdentity=='1' && ele.custCreditCode == $scope.saleCreditCode)) {
                        flag = true // 可回退
                    }
                }
                // 有关联销售单且为 审核通过, 开具状态为 "未开具" 或 "开具失败"
                if (ele.isList == '1' && ele.workflowStatus == '1' && ['0', '3'].indexOf(ele.openStatus) !== -1 && (ele.custIdentity=='0'&& ele.saleCreditCode == $scope.saleCreditCode)||(ele.custIdentity=='1' && ele.custCreditCode == $scope.saleCreditCode)) {
                    flag = true // 可回退
                }
                break
            case 2: //销售单
                if (['01', '02', '04'].indexOf(ele.confirmStatus) !== -1) {
                    // 确认单来源为“销售单” 确认单状态不是“未上传”且不是作废状态时，
                    // 即状态为“销方申请待购方确认”或“无需确认”或“购销双方已确认”，此时不可回退，不显示【回退】按钮。
                } else {
                    if((ele.custIdentity=='0'&& ele.saleCreditCode == $scope.saleCreditCode)||(ele.custIdentity=='1' && ele.custCreditCode == $scope.saleCreditCode)){
                        flag = true // 可回退
                    }
                }
                break
            default:
                break
            }
            console.log(flag)
            return flag
        }
        function checkRevokeItem(ele) {
            let flag = false
            switch (ele.openStatus) {
            case '0': //未开具
                if(ele.confirmStatus === '04' && ele.confirmName === $scope.orgName){
                    flag = true // 可撤销
                }
                if(ele.confirmStatus=== '01' || ele.confirmStatus === '02' || ele.confirmStatus === '03'){
                    if(ele.createIdentity=='0' && ele.saleCreditCode == $scope.saleCreditCode){
                        flag = true // 可撤销
                    }
                    if(ele.createIdentity=='1' && ele.custCreditCode == $scope.saleCreditCode){
                        flag = true // 可撤销
                    }
                }
                break
            case '1': //开具成功
            case '2': //开具中
            case '3': //开具失败
            default:
                break
            }
            return flag
        }

        function realBack(selectedRows, type, batchOperate) {
            const confirmIds = selectedRows.map((row) => {
                return row.confirmId
            })
            // rollbackFlag 校验：0  回退：1
            // batchOperate 单张回退：false   批量回退：true
            httpRequest.post_batchRollbackRedConfirm(confirmIds,1, batchOperate).then((res) => {
                if (type === 1) {
                    if (res.data.value.success == 1) {
                        logger.logSuccess('回退成功')
                    } else {
                        logger.logError(res.data.value.messageList[0].errorMsg)
                    }
                } else {
                    logger.logSuccess(`回退成功${res.data.value.success}条，回退失败${res.data.value.error}条，自动匹配关联${res.data.value.matching}条！`)
                }

                queryRedInfo()
            })
        }
        // 单张撤销
        $scope.oneRevoke = async function (item) {
            let selectedRows = []
            if (item) {
                selectedRows = [item]
            } else {
                selectedRows = $scope.selectedRows
            }
            if (!selectedRows.length) {
                return logger.logError('请选择要撤销的数据行')
            }
            const ukeyId = await chooseUkey('红字确认单撤销', '您正在进行红字确认单撤销操作，撤销后请注意查看确认单状态。请注意：乐企平台不支持进行红字确认单撤销，如需撤销请选择管理方式为电子税局的开票点，或到电子税局进行撤销操作。',  selectedRows[0].ukeyId)
            if (!ukeyId) return
            const confirmId = selectedRows.map((row) => {
                return row.confirmId
            })
            httpRequest.post_revokeTax4RedConfirm(confirmId, ukeyId).then((res) => {
                logger.logSuccess('撤销成功！')
                queryRedInfo()
            })
        }
        // 批量撤销
        $scope.batchRevoke = async function (item) {
            let selectedRows = []
            if (item) {
                selectedRows = [item]
            } else {
                selectedRows = $scope.selectedRows
            }
            if (!selectedRows.length) {
                return logger.logError('请选择要撤销的数据行')
            }
            let checkRows = selectedRows.some((ele) => {
                return checkRevokeItem(ele)
            })
            if (!checkRows) {
                return logger.logError(
                    '确认单状态为“销购双方已确认”，且开具状态为“未开具”的红字确认单，当前操作机构若为确认方才可撤销；确认单状态为“无需确认”、“销方录入待购方确认”或“购方录入待销方确认”,且开具状态为“未开具”红字确认单,当前操作机构若为录入方才可撤销，请核实后重新选择。'
                )
            }
            const ukeyId = await chooseUkey('红字确认单撤销', '您正在进行红字确认单撤销操作，撤销后请注意查看确认单状态。请注意：乐企平台不支持进行红字确认单撤销，如需撤销请选择管理方式为电子税局的开票点，或到电子税局进行撤销操作。', selectedRows[0].ukeyId)
            if (!ukeyId) return
            const confirmIds = selectedRows.map((row) => {
                return row.confirmId
            })
            httpRequest.post_batchRevokeTax4RedConfirm(confirmIds, ukeyId).then((res) => {
                if (item && res.data.value.successCnt === 1) {
                    logger.logSuccess(`撤销成功！`)
                } else {
                    logger.logSuccess(`撤销成功${res.data.value.successCnt}条，失败${res.data.value.failCnt}条。`)
                }
                queryRedInfo()
            })
        }

        // 批量删除
        $scope.batchDelete = function (item) {
            let selectedRows = []
            if (item) {
                selectedRows = [item]
            } else {
                selectedRows = $scope.selectedRows
            }
            if (!selectedRows.length) {
                return logger.logError('请选择要删除的数据行')
            }
            //内部审核状态为“待提交”、“审核不通过”或“被回退”的确认单  -1  3  4
            let checkRows = selectedRows.some((ele) => {
                return !(
                    (ele.dataSource == '0' || ele.dataSource == '3') &&
                    (ele.workflowStatus == '-1' || ele.workflowStatus == '3' || ele.workflowStatus == '4') &&
                    (ele.confirmStatus === '0' || ele.confirmStatus === '1')
                )
            })
            if (checkRows) {
                return logger.logError('确认单来源为“手工新增”或“接口”，内部审核状态为“待提交”或“审核不通过”或“被回退”，确认单状态为“未上传”或“上传失败”的红字确认单才可删除，请核实后重新选择。')
            }

            sweetalert.confirm('删除提醒', '确认删除所选的发票信息？').then(() => {
                httpRequest.post_tax4RedConfirmBatchDelete(selectedRows).then(() => {
                    logger.logSuccess('删除成功！')
                    queryRedInfo()
                })
            })
        }
        // 发送确认提醒
        $scope.batchSend = function (item) {
            let selectedRows = []
            if (item) {
                selectedRows = [item]
            } else {
                selectedRows = $scope.selectedRows
            }
            if (!selectedRows.length) {
                return logger.logError('请选择要删除的数据行')
            }
            if(selectedRows.length >100){
                return logger.logError('每次最多选择100张红字确认单批量提醒')
            }
            const confirmIds = selectedRows.map((row) => {
                return row.confirmId
            })
            //确认单状态 不是02-销方录入待购方确认/03-购方录入待销方确认的
            let checkRows = false
            if(selectedRows.some((ele) => !(ele.confirmStatus === '02' || ele.confirmStatus === '03'))){
                checkRows = true
            }
            // 发起方不一致
            let checkIs = false
            for(let i = 0; i < selectedRows.length; i++){
                if(selectedRows.some(item => item !== selectedRows[i] && item.otherSideName !== selectedRows[i].otherSideName)){
                    checkIs = true
                }
            }
            let data = {
                checkRows:checkRows,
                checkIs:checkIs,
            }
            $uibModal
                .open({
                    template: sendEmailModel,
                    controller: 'sendEmailCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-md',
                    resolve: {
                        items1() {
                            return data
                        },
                    },
                })
                .result.then(
                    (result) => {
                        if (result) {
                            httpRequest.post_batchSendConfirmMail(confirmIds,result).then(() => {
                                logger.logSuccess('邮件已发送！')
                                queryRedInfo()
                            })
                        }
                    },
                    () => {}
                )

        }
    }
}
redInkConfirmFormListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'sweetalert', 'initSortService', 'composeService', '$location', 'dictService']



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/list.js